module.exports = __webpack_public_path__ + "41e8dead03fb979ecc23b8dfb0fef627.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Regular.ttf
// module id = 1260
// module chunks = 0